export const addresses = {
  alphatoken: "0x1A774ba5673de03139e672F762F67EFf29fa1CA0",
};
